import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, model, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

@Component({
	selector: 'xp-phone-field',
	standalone: true,
	imports: [
		CommonModule,
		FormsModule,
		MatButtonModule,
		MatFormFieldModule,
		MatIconModule,
		MatInputModule
	],
	templateUrl: './xp-phone-field.component.html',
	styleUrls: ['./xp-phone-field.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class XpPhoneFieldComponent {
	countryCode = input('');
	placeholder = input('');
	maxLength = input<number | null>(null);
	value = model('');
	clear = output<void>();
}
